import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DOBPickerInput = ({
  id,
  label,
  value,
  onChange,
  disabled = false,
  required = false,
  invalid = false,
  maxDate = new Date(),
  labelPosition = "left", // "top" | "left"
}) => {
  const isTop = labelPosition === "top";

  return (
    <div
      className={`w-full mb-4 ${
        isTop
          ? "flex flex-col gap-1"
          : "flex items-center gap-4"
      }`}
    >
      {label && (
        <label
          htmlFor={id}
          className={`text-base font-medium text-black ${
            isTop ? "" : "whitespace-nowrap"
          }`}
        >
          {label}
          {required && <span className="text-red-500"> *</span>}
        </label>
      )}

      <div className={isTop ? "w-full" : "flex-1"}>
        <DatePicker
          id={id}
          selected={value || null}
          onChange={onChange}
          dateFormat="MM/dd/yyyy"
          maxDate={maxDate}
          disabled={disabled}
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          scrollableMonthYearDropdown
          wrapperClassName="w-full"
          className={`w-full px-0 py-2 border-0 border-b-2 rounded-none shadow-none
          ${invalid ? "border-b-red-600 bg-red-50 ring-2 ring-red-300 focus:ring-red-400" : "bg-slate-50 border-b-gray-300"}
            ${disabled ? "!text-black !opacity-100" : ""}
            focus:outline-none focus:ring-0 focus:border-b-indigo-500
             font-medium
          `}
        />
      </div>
    </div>
  );
};

export default DOBPickerInput;
